import React from 'react';
import styled from 'styled-components';

import { getInferenceProviderColour, getInferenceProviderLogo } from '@common/Autocomplete/Base';
import { useTheme } from '../../../../../styles';
import { alpha, Stack } from '@mui/material';

const Container = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.text.subtext};

  padding: 0.75rem 1rem;
  border-radius: 7px 7px 0 0;
  font-family: 'Inter';

  border-bottom: 1px solid ${({ theme }) => theme.line.node};

  #label {
    color: ${({ theme }) => theme.text.subtext};
    font-size: 9px;
    font-weight: 300;
    margin-bottom: 1px;
    font-family: 'Inter';
  }

  #model {
    color: ${({ theme }) => theme.text.standard};
    font-size: 10px;
    font-weight: 400;
    font-family: 'Inter';
  }

  & .MuiBadge-badge {
    color: white;
    height: 12px;
    min-width: 12px !important;
    max-width: 12px !important;
    font-size: 8px;
    padding: 0;
    left: -10 !important;
    margin-right: 0.25rem;
    margin-top: 0.15rem;
  }

  & .MuiChip-root {
    padding: 8px;
    padding-right: 4px;
  }
`;

const ProviderLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 31px;
  width: 31px;
  border-radius: 6px;
  background-color: ${({ theme }) => alpha(theme.text.standard, 0.06)};
  border: ${({ theme }) => `1px solid ${theme.line.light}`};
`;

interface Props {
  model: string;
}

export const ProviderModel: React.FC<Props> = ({ model }) => {
  const theme = useTheme();
  const logoColor = getInferenceProviderColour(theme, model.split('/')[0]);
  const logo = getInferenceProviderLogo(model.split('/')[0], theme.text.standard);

  return (
    <Container>
      <Stack spacing={1} direction='row' alignItems='center'>
        <ProviderLogo color={logoColor}>{logo}</ProviderLogo>
        <Stack>
          <p id='label'>Model</p>
          <p id='model'>{model?.split('/')[1]}</p>
        </Stack>
      </Stack>
    </Container>
  );
};
